import React, { Component, PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import {
  Link,
  LinkIcon,
  CompanyIsFlag
} from '../'
import Styles from './CompanyIsFff.css'


@CSSModules(Styles, {allowMultiple:true})
export default class CompanyIsFff extends Component {
  static propTypes = {
    company: PropTypes.object.isRequired,
  }
  constructor(props){
    super(props)
    this.state = {}
  }

  render() {
    const iconFfb = require( '../../../static/images/icn-ffb.svg' )
    const iconFfi = require( '../../../static/images/icn-ffi.svg' )
    const iconC2 = require( '../../../static/images/icn-c2.svg' )
    const iconCo = require( '../../../static/images/icn-co.svg' )
    const iconOg = require( '../../../static/images/icn-og.svg' )
    const iconF5 = require( '../../../static/images/icn-f5.svg' )
    const iconUt = require( '../../../static/images/icn-ut.svg' )
    //
    return <div styleName='family-modal'>
      <div styleName='icon-row'>
        {
          this.props.company.is_c2 ?
            <CompanyIsFlag icon={iconC2} title='Top 200 carbon reserve owner' color='red'/> :
            null
        }
        {
          this.props.company.is_f15 ?
            <CompanyIsFlag icon={iconC2} title='Top 50 Coal-fired utilities' color='red'/> :
            null
        }
        {
          this.props.company.is_co ?
            <CompanyIsFlag icon={iconCo} title='Coal industry'/> :
            null
        }
        {
          this.props.company.is_og ?
            <CompanyIsFlag icon={iconOg} title='Oil/gas industry'/> :
            null
        }
        {
          this.props.company.is_ut ?
            <CompanyIsFlag icon={iconUt} title='Fossil-fired utilities'/> :
            null
        }
        {
          this.props.company.is_fossil_bank ?
            <CompanyIsFlag icon={iconFfb} title='Fossil fuel finance'/> :
            null
        }
        {
          this.props.company.is_fossil_insure ?
            <CompanyIsFlag icon={iconFfi} title='Fossil fuel insurance'/> :
            null
        }
      </div>
    </div>
  }
}

